import type { VoteType } from "query/graphql"

export const SUPPORT_NUMBERS: {
  [type in VoteType]: number
} = {
  against: 0,
  for: 1,
  abstain: 2,
  pendingabstain: 3,
  pendingagainst: 4,
  pendingfor: 5,
}
